"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _statusToTheme = require("./statusToTheme");
Object.keys(_statusToTheme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _statusToTheme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _statusToTheme[key];
    }
  });
});